import React from "react";
import { Menu } from "lucide-react";
import { useSidebar } from "./SidebarContext";


const SidebarToggle = ({side}) => {
  const { toggle, isOpen, side: contextSide} = useSidebar();
  const resolvedSide = side || contextSide;

  return (
    <button
      type="button"
      className="av-sidebar-toggle" 
      side={resolvedSide}
      aria-label="Toggle menu"
      aria-expanded={isOpen}
      onClick={toggle}
    >
      <Menu size={20} />
    </button>
  );
};

export default SidebarToggle;
